/* eslint-disable import/prefer-default-export */
export function setLanguage(payload) {
    return {
        type: 'SET_LANGUAGE',
        payload,
    };
}
